export default __webpack_public_path__ + "static/media/donut@2x.0ec3e61e.png";